import {useListFilterValues} from "../../../../hooks/hooks";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {FilterContentType, TableFilter} from "../../../../types/tableFilter";
import {OrganShareFilterWordType} from "../../../../types/organShare";
import {useOrganShareConverter} from "./useOrganShareConverter";

interface Args {
    search: () => void;
}

export function useOrganShareFilters({search}: Args) {
    const {t} = useTranslation(["filter", "common"]);
    const {filterValues} = useListFilterValues();

    const {getSearchWordConverter} = useOrganShareConverter();

    const searchWordTypeFilter = useMemo(
        () => filterValues.searchWordTypeFilterValue,
        [filterValues.searchWordTypeFilterValue]
    );
    const searchWordFilter = useMemo(() => filterValues.searchWordFilterValue, [filterValues.searchWordFilterValue]);
    const isCheckedFilter = useMemo(() => filterValues.isCheckedFilterValue, [filterValues.isCheckedFilterValue]);

    const filters: TableFilter[][] = [
        [
            {
                labelTitle: "검색어",
                content: {
                    type: FilterContentType.TEXT,
                    value: searchWordFilter?.value,
                    maxLength: 100,
                    placeholderVal: t("searchWord.placeholder"),
                    onChangeFunc: (v) => searchWordFilter.setter(v),
                    onEnterKeyUpFunc: search,
                    isDisabled: isCheckedFilter.value,
                    typeSelector: {
                        type: FilterContentType.SELECT,
                        value: searchWordTypeFilter?.value,
                        isDisabled: isCheckedFilter.value,
                        options: [
                            {label: "전체", value: ""},
                            {
                                value: OrganShareFilterWordType.MANAGER_NAME,
                                label: getSearchWordConverter(OrganShareFilterWordType.MANAGER_NAME),
                            },
                            {
                                value: OrganShareFilterWordType.CELL_PHONE,
                                label: getSearchWordConverter(OrganShareFilterWordType.CELL_PHONE),
                            },
                            {
                                value: OrganShareFilterWordType.ID,
                                label: getSearchWordConverter(OrganShareFilterWordType.ID),
                            },
                            {
                                value: OrganShareFilterWordType.ORGAN_NAME,
                                label: getSearchWordConverter(OrganShareFilterWordType.ORGAN_NAME),
                            },

                        ],
                        onChangeFunc: (v) => searchWordTypeFilter?.setter(v as OrganShareFilterWordType),
                    },
                },
            },
        ],
        [
            {
                labelTitle: "공유된 소속 검색",
                content: {
                    type: FilterContentType.CHECK_BOX,
                    isChecked: isCheckedFilter.value,

                    onChangeFunc: (v) => isCheckedFilter?.setter(v as boolean),
                },
            },
        ]
    ]

    return{
        filters
    }
}